module.exports = __webpack_public_path__ + "img/loading.1d94bc8a.png";